import React, { PropsWithChildren } from 'react';
import useFormContainer, { FormContext, FormProps } from 'new/elements/Form/useForm';
import { Prompt } from 'react-router-dom';
import FormErrorDisplay from './components/FormErrorDisplay/FormErrorDisplay';

const exitWorkflowMessage =
  'Are you sure you want to exit this editor? All of your current changes will be discarded.';

interface FormProviderProps extends Omit<FormProps, 'children'> {
  formType?: string;
}

export const FormProvider = (props: PropsWithChildren<FormProviderProps>) => {
  const { formType, children, ...restProps } = props;
  const formProps = {
    ...restProps,
    // @ts-ignore
    children: props?.children?.props?.children,
  };
  const formState = useFormContainer(formProps);

  return (
    <>
      {!props.isModal && (
        <Prompt
          message={exitWorkflowMessage}
          when={!formState.showLeaveConfirmation && !formState.finished}
        />
      )}
      <FormContext.Provider value={formState}>{children}</FormContext.Provider>
      {formType && <FormErrorDisplay formType={formType} />}
    </>
  );
};
